module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid mdl-grid--no-spacing line-gauge-container"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--middle lg-label mdl-typography--body-1 typography--color-secondary"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--middle lg-box"
  }, [_c('LineGauge', {
    attrs: {
      "value": _vm.value,
      "bg-color": _vm.bgColor
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--middle lg-position-num mdl-typography--body-1 typography--color-secondary"
  }, [_vm._v("\n    " + _vm._s(_vm.value) + _vm._s(_vm.unit) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401cfa8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicLineGauge.vue
// module id = 1570
// module chunks = 1